import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const EntryListWidgetSelectAccount = ({
  multipleAccountSelected,
}: {
  multipleAccountSelected?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        mt: 69.5,
        textAlign: 'center',
      }}
    >
      <Typography variant="text1" color="text.secondary">
        {multipleAccountSelected
          ? t('dashboard.placeholders.selectSingleAccount')
          : t('dashboard.placeholders.selectAccount')}
      </Typography>
    </Box>
  );
};
